import { LogoProps } from './types';

const Gerrit = ({ size = 24, className }: LogoProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 52 52"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="0" y="0" width="40" height="40" rx="4" ry="4" fill="#FFAAAA" />
    <rect x="12" y="12" width="40" height="40" rx="4" ry="4" fill="#AAFFAA" />
    <path d="M18 22h12v4H18v-4z" fill="#FF0000" />
    <path d="M34 22h12v4H34v-4z" fill="#FF0000" />
    <path d="M18 36h4v-4h4v4h4v4h-4v4h-4v-4h-4v-4z" fill="#008000" />
    <path d="M34 36h4v-4h4v4h4v4h-4v4h-4v-4h-4v-4z" fill="#008000" />
  </svg>
);

export default Gerrit;
